import { concatStyleSets } from "@fluentui/react";
export function getBaseDialogModalStyle(theme) {
    return {
        main: {
            background: theme.customSemanticColors.solidBackgroundBase,
            borderRadius: "6px",
            color: theme.customSemanticColors.textPrimary,
            display: "flex",
            height: "670px",
            minWidth: "652px",
            padding: "0px",
            width: "652px",
        },
        root: {
            padding: "0px",
        },
        scrollableContent: {
            height: "100%",
        },
    };
}
export function getBasicSettingsStyle() {
    return {
        root: {
            alignContent: "center",
            display: "flex",
            flexWrap: "wrap",
        },
    };
}
export function getMainActionStackStyles() {
    return {
        root: {
            margin: "0px 0px 4px 0px",
        }
    };
}
export function getMainExpandoStyle() {
    return {
        root: {
            margin: "0px 0px 4px 0px",
        }
    };
}
export function getTitleSectionStyles() {
    return {
        root: {
            display: "flex",
            margin: "0px",
            padding: "32px 26px 16px 32px",
        }
    };
}
export function getTitleStackStyle() {
    return {
        root: {
            alignContent: "baseline",
        }
    };
}
export function getTitleStyles(theme) {
    return {
        root: {
            color: theme.customSemanticColors.textPrimary,
            fontSize: "20px",
            fontWeight: "600",
            lineHeight: "28px",
            marginBlockEnd: "0px",
            marginBlockStart: "0px",
            textAlign: "left",
        }
    };
}
export function getSubTitleStyles(theme) {
    return {
        root: {
            color: theme.customSemanticColors.textPrimary,
            fontSize: "14px",
            fontWeight: "600",
            lineHeight: "20px",
            marginBlockEnd: "0px",
            marginBlockStart: "0px",
            textAlign: "left",
        }
    };
}
export function getBreadCrumbTitleStyleStacks(theme) {
    // Overrides Link focus/hover behavior to match appearance of Settings App
    return {
        root: {
            ":focus": {
                color: theme.customSemanticColors.textSecondary,
                textDecoration: "none",
            },
            ":focus:hover": {
                color: theme.customSemanticColors.textPrimary,
                textDecoration: "none",
            },
            ":hover": {
                color: theme.customSemanticColors.textPrimary,
                textDecoration: "none",
            },
            color: theme.customSemanticColors.textSecondary,
        }
    };
}
export function getTitleChevronStyles(theme) {
    return {
        root: {
            color: theme.customSemanticColors.textPrimary,
            fontSize: "16px",
            padding: " 0px 12px", // Allows baseline alignment while giving the 12px padding on either side.
        }
    };
}
export function getSettingsScrollableAreaStyle() {
    return {
        root: {
            height: "578px",
            margin: "16px 24px 0px 32px ",
            maxHeight: "602px",
            padding: "0px 0px 32px 0px",
        }
    };
}
export function getDisplayFlex(styles) {
    return concatStyleSets(getBasicSettingsStyle(), styles);
}
export function getModalCloseButtonStyle(theme) {
    return {
        root: {
            "::before": {
                content: "",
            },
            // Styles needed to adjust our app-wide focus-visual to inset to show within the dialog close
            // button at the edge of the dialog, such that it isn't cutoff at the edge.
            ":focus-visible": {
                boxShadow: "0 0 0 2px " + theme.customSemanticColors.focusOuter + " inset",
            },
            background: "transparent",
            position: "absolute",
            right: "0px",
            top: "0px",
        },
        rootHovered: {
            "::before": {
                content: "",
            },
            background: theme.customSemanticColors.subtleFillSecondary,
        },
        rootPressed: {
            "::before": {
                content: "",
            },
            background: theme.customSemanticColors.subtleFillTertiary,
        },
    };
}
export function getRTLModalCloseButtonStyle(theme) {
    return {
        root: {
            "::before": {
                content: "",
            },
            // Styles needed to adjust our app-wide focus-visual to inset to show within the dialog close
            // button at the edge of the dialog, such that it isn't cutoff at the edge.
            ":focus-visible": {
                boxShadow: "0 2px 0 0 " + theme.customSemanticColors.focusOuter + " inset",
            },
            background: "transparent",
            left: "0px",
            position: "absolute",
            top: "0px",
        },
        rootHovered: {
            "::before": {
                content: "",
            },
            background: theme.customSemanticColors.subtleFillSecondary,
        },
        rootPressed: {
            "::before": {
                content: "",
            },
            background: theme.customSemanticColors.subtleFillTertiary,
        },
    };
}
export function getModalCloseButtonIconStyle() {
    return {
        root: {
            fontSize: "10px",
        },
    };
}
export function getExpandoContentStackStyles() {
    return {
        root: {
            alignContent: "center",
            display: "flex",
            flexWrap: "wrap",
            width: "100%"
        }
    };
}
export function getBulletIconStyle(theme) {
    return {
        root: {
            color: theme.customSemanticColors.textDisabled,
            verticalAlign: "middle",
        },
    };
}
export function getHideConsentModalDialogStyles(theme) {
    return {
        main: {
            background: theme.customSemanticColors.solidBackgroundBase,
            borderRadius: "7px",
            color: theme.customSemanticColors.textPrimary,
            display: "flex",
            height: "256px",
            minWidth: "448px",
            padding: "0px",
            width: "448px",
        },
        root: {
            padding: "0px",
        },
        scrollableContent: {
            height: "100%",
            padding: "0px",
            width: "100%",
        },
    };
}
export function getHideConsentDialogContentStyles() {
    return {
        root: {
            padding: "24px 24px 23px 24px",
            width: "448px",
        }
    };
}
export function getHideConsentDialogTitleStyles() {
    return {
        root: {
            fontSize: "20px",
            fontWeight: "600",
            lineHeight: "28px",
            paddingBottom: "12px",
        }
    };
}
export function getHideConsentDialogSubTitleStyles() {
    return {
        root: {
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "20px",
        }
    };
}
export function getHideConsentButtonAreaStyles(theme) {
    return {
        root: {
            background: theme.customSemanticColors.solidBackgroundSecondary,
            color: theme.customSemanticColors.textPrimary,
            display: "flex",
            fontSize: "14px",
            fontWeight: "400",
            height: "80px",
            lineHeight: "20px",
            padding: "24px",
            width: "448px",
        },
    };
}
export function getHideConsentButtonStyles() {
    return {
        root: {
            width: "196px",
        }
    };
}
export function getNotificationsSubHeaderStyles() {
    return {
        root: {
            alignContent: "left",
            flexFlow: "column",
            padding: "8px 0px 4px 0px", // Margins of 12 0 8 0, adjusted by the +4 given to all children.
        }
    };
}
export function getNotificationsErrorStyles() {
    return {
        root: {
            alignContent: "center",
            height: "100%",
            justifyContent: "center",
        }
    };
}
export function getNotificationsErrorTextStyles() {
    return {
        root: {
            height: "auto",
            maxWidth: "100%",
            textAlign: "center",
        }
    };
}
export function getNotificationsEnabledArea() {
    return {
        root: {
            alignContent: "center",
            display: "flex",
            flexFlow: "column",
            flexWrap: "wrap",
            width: "100%"
        }
    };
}
export function addPreserveWhitespaceStyle(styles) {
    const preserveWhitespaceStyle = {
        root: {
            whiteSpace: "pre",
        }
    };
    return concatStyleSets(preserveWhitespaceStyle, styles);
}
